import React, { useState } from "react";
import { statsIcons } from '../../assets/images/userStatistics';

const Calendar = () => {
  const [date, setDate] = useState(new Date());

  const months = [
    "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
  ];

  const generateCalendar = () => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const today = new Date();

    const dayone = new Date(year, month, 1).getDay();
    const lastdate = new Date(year, month + 1, 0).getDate();
    const dayend = new Date(year, month, lastdate).getDay();
    const monthlastdate = new Date(year, month, 0).getDate();

    const days = [];

    // Dates du mois précédent
    for (let i = dayone - 1; i > 0; i--) {
      days.push(<li key={`p-${i}`} className="inactive">{monthlastdate - i + 1}</li>);
    }

    // Dates du mois courant
    for (let i = 1; i <= lastdate; i++) {
      const isToday = i === today.getDate() &&
        month === today.getMonth() &&
        year === today.getFullYear();
      days.push(<li key={`c-${i}`} className={isToday ? "active" : ""}>{i}</li>);
    }

    // Dates du mois suivant
    for (let i = dayend + 1; i <= 7; i++) {
      days.push(<li key={`n-${i}`} className="inactive">{i - dayend}</li>);
    }

    return days;
  };

  const handlePrev = () => {
    setDate(new Date(date.getFullYear(), date.getMonth() - 1, 1));
  };

  const handleNext = () => {
    setDate(new Date(date.getFullYear(), date.getMonth() + 1, 1));
  };

  return (
    <div className="calendar stat-card">
      <div className="title">
        <h4>Série en cours</h4>
      </div>
      <div className="calendar-container">
        <div className="calendar-header">
          <div className="calendar-navigation">
            <div id="calendar-prev" onClick={handlePrev}>
              <img src={statsIcons.chevronLeft} alt="Chevron gauche" />
            </div>
            <p className="calendar-current-date">
              {months[date.getMonth()]} {date.getFullYear()}
            </p>
            <div id="calendar-next" onClick={handleNext}>
              <img src={statsIcons.chevronRight} alt="Chevron droit" />
            </div>
          </div>
        </div>

        <div className="calendar-body">
          <ul className="calendar-weekdays">
            <li>lun</li>
            <li>mar</li>
            <li>mer</li>
            <li>jeu</li>
            <li>ven</li>
            <li>sam</li>
            <li>dim</li>
          </ul>
          <ul className="calendar-dates">{generateCalendar()}</ul>
        </div>
      </div>
    </div>
  );
};

export default Calendar;